import type { IGroup } from '../types/types'

type LevelNames = Record<string, string>

interface GamificationSettingsCarrier {
  settings?: { gamificationSettings?: { levelNames?: unknown } & Record<string, unknown> } & Record<string, unknown>
}

/**
 * Removes `settings.gamificationSettings.levelNames` from a group update. The backend overwrites the
 * stored level names whenever the key is present (`{}` resets all), and most group payloads carry a
 * stale legacy copy, so names are only ever written through the gamification levels endpoint.
 */
export function omitGamificationLevelNames<T extends object>(updates: T): T {
  const { settings } = updates as GamificationSettingsCarrier
  const gamificationSettings = settings?.gamificationSettings
  if (!gamificationSettings || !('levelNames' in gamificationSettings)) {
    return updates
  }

  const { levelNames: _staleLevelNames, ...gamificationRest } = gamificationSettings
  return {
    ...updates,
    settings: { ...settings, gamificationSettings: gamificationRest },
  }
}

/** New group carrying the given level names, so readers of the cached group see current names. */
export function withGamificationLevelNames(group: IGroup, levelNames: LevelNames): IGroup {
  return {
    ...group,
    settings: {
      ...group.settings,
      gamificationSettings: {
        ...group.settings?.gamificationSettings,
        levelNames,
      },
    },
  }
}
